import React from "react";
import { Badge } from "../components/ui/badge";
import { Button } from "../components/ui/button";
import { Card, CardContent } from "../components/ui/card";
import { Input } from "../components/ui/input";
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from "../components/ui/select";
import { Table, TableBody, TableCell, TableHead, TableHeader, TableRow } from "../components/ui/table";

import { useMemo, useState } from "react";
import { Link } from "react-router-dom";
import { useModelIndex } from "@rhino-project/core/hooks";
import { asSubmission, listResults } from "../lib/thirdDoorAdapters";

export default function InboundQueue() {
    const { resources } = useModelIndex("submission" as any, { limit: 50 } as any);
    const items = listResults(resources).map(asSubmission);
    const [search, setSearch] = useState("");
    const [confidence, setConfidence] = useState("all");
    const [weakSignal, setWeakSignal] = useState("all");
    const filtered = useMemo(() => items.filter((item) => {
      const matchesSearch = item.submission.toLowerCase().includes(search.toLowerCase());
      const matchesConfidence = confidence === "all" || item.confidence === confidence;
      const matchesWeakSignal = weakSignal === "all" || item.weakSignal === weakSignal;
      return matchesSearch && matchesConfidence && matchesWeakSignal;
    }), [search, confidence, weakSignal]);
    const clearFilters = () => {
      setSearch("");
      setConfidence("all");
      setWeakSignal("all");
    };
  return (
   <div className="w-full min-w-0 bg-background text-foreground overflow-x-hidden">
      <div className="mx-auto flex w-full max-w-7xl min-w-0 flex-col gap-6 px-4 py-6 sm:px-6 lg:px-8">
          <section className="w-full space-y-4">
      <Card className="border-border shadow-sm">
      <CardContent className="grid gap-3 p-4 md:grid-cols-[1fr_220px_220px_auto]">
      <Input value={search} onChange={(event) => setSearch(event.target.value)} placeholder="Search queue" />
      <Select value={confidence} onValueChange={setConfidence}>
      <SelectTrigger><SelectValue placeholder="Confidence" /></SelectTrigger>
      <SelectContent className="bg-popover text-popover-foreground">
      <SelectItem value="all">All confidence</SelectItem>
      <SelectItem value="High">High</SelectItem>
      <SelectItem value="Medium">Medium</SelectItem>
      </SelectContent>
      </Select>
      <Select value={weakSignal} onValueChange={setWeakSignal}>
      <SelectTrigger><SelectValue placeholder="Weak signal" /></SelectTrigger>
      <SelectContent className="bg-popover text-popover-foreground">
      <SelectItem value="all">All</SelectItem>
      <SelectItem value="No">No</SelectItem>
      <SelectItem value="Yes">Yes</SelectItem>
      </SelectContent>
      </Select>
      <Button variant="outline" onClick={clearFilters}>Reset</Button>
      </CardContent>
      </Card>

      <Card className="border-border shadow-sm">
      <CardContent className="p-0">
      <div className="overflow-x-auto">
      <Table>
      <TableHeader>
      <TableRow>
      <TableHead>Submission</TableHead>
      <TableHead>Sector</TableHead>
      <TableHead>Confidence</TableHead>
      <TableHead>Likely End-User</TableHead>
      <TableHead>Status</TableHead>
      <TableHead className="text-right">Action</TableHead>
      </TableRow>
      </TableHeader>
      <TableBody>
      {filtered.map((item) => (
      <TableRow key={item.id}>
      <TableCell className="font-medium">{item.submission}</TableCell>
      <TableCell>{item.sector}</TableCell>
      <TableCell>{item.confidence}</TableCell>
      <TableCell>{item.endUser}</TableCell>
      <TableCell><Badge variant={item.weakSignal === "Yes" ? "outline" : "secondary"}>{item.status}</Badge></TableCell>
      <TableCell className="text-right">
      <Button asChild size="sm" variant="outline">
      <Link to="/sponsor-view/submission-detail">View</Link>
      </Button>
      </TableCell>
      </TableRow>
      ))}
      </TableBody>
      </Table>
      </div>
      </CardContent>
      </Card>
      </section>
      </div>
    </div>
  );
}